import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const Bar = styled.div`
  width: 100%;
  background: ${getToken('color-neutral-lighter')};
  border-radius: ${getToken('border-radius-m')};
  position: relative;
  overflow: hidden;
  flex: 1;
`

export const Progress = styled.div<{ $value: number }>`
  width: ${({ $value }) => $value}%;
  height: 8px;
  background: ${getToken('color-warning')};
  transition: 600ms ease;
`
